/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Download': {
    width: 20,
    height: 19,
    viewBox: '0 0 20 19',
    data: '<path pid="0" d="M9.23 4.79V.783C9.23.355 9.57 0 10 0c.385 0 .711.298.763.677l.007.105V4.79h4.78c2.38 0 4.335 1.949 4.445 4.38l.005.215v5.04c0 2.447-1.887 4.456-4.232 4.569L15.56 19H4.44C2.06 19 .114 17.06.005 14.621L0 14.405v-5.03c0-2.447 1.878-4.466 4.222-4.58l.208-.004h4.8v6.402l-1.6-1.652a.755.755 0 00-1.09 0 .81.81 0 00-.22.568c0 .157.045.32.14.459l.08.099 2.91 3.015c.14.155.34.237.55.237a.735.735 0 00.465-.166l.075-.071 2.91-3.015c.3-.31.3-.816 0-1.126a.755.755 0 00-1.004-.077l-.086.077-1.59 1.652V4.791H9.23z" _fill="#243143" fill-opacity=".4"/>'
  }
})
